import { render, staticRenderFns } from "./CustomFormButton.vue?vue&type=template&id=24377260&scoped=true"
import script from "./CustomFormButton.vue?vue&type=script&lang=js"
export * from "./CustomFormButton.vue?vue&type=script&lang=js"
import style0 from "./CustomFormButton.vue?vue&type=style&index=0&id=24377260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24377260",
  null
  
)

export default component.exports